import { ExposedValueMetricCard as CoreExposedValueMetricCard } from "@/core/components/exposed-values/ExposedValueMetricCard";
import type { ExposedValueDefinition, ExposedValueMapping, RealTimeValue } from "@/modules/energy/types";

interface ExposedValueMetricCardProps {
  definition: ExposedValueDefinition;
  mapping: ExposedValueMapping | null;
  realTimeValues: Record<string, RealTimeValue>;
  onSelect: () => void;
  onOpenChart: (mapping: ExposedValueMapping) => void;
  disabled?: boolean;
}

export const ExposedValueMetricCard = (props: ExposedValueMetricCardProps) => (
  <CoreExposedValueMetricCard translationPrefix="mod_energy.energy_management" {...props} />
);
